var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownProtocol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7282 17H6.70312C6.31494 17 6 17.3148 6 17.7031C6 18.0913 6.31494 18.4063 6.70312 18.4063H12.7282C13.1164 18.4063 13.4313 18.0913 13.4313 17.7031C13.4313 17.3148 13.1166 17 12.7282 17Z",
    fill: "#364863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7282 19.0566H6.70312C6.31494 19.0566 6 19.3714 6 19.7598C6 20.1479 6.31494 20.4629 6.70312 20.4629H12.7282C13.1164 20.4629 13.4313 20.1479 13.4313 19.7598C13.4313 19.3714 13.1166 19.0566 12.7282 19.0566Z",
    fill: "#364863"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8124 0H8.26868C8.08228 0 7.90338 0.0741577 7.77155 0.205994L3.25287 4.72467C3.12103 4.85651 3.04688 5.0354 3.04688 5.2218V21.7906C3.04688 23.0089 4.03802 24 5.25623 24H18.8124C20.0272 24 21.0218 23.0178 21.0218 21.7906V2.20935C21.0218 0.994629 20.0398 0 18.8124 0ZM8.31866 1.6474V4.46869C8.31866 4.91162 7.9585 5.27179 7.51556 5.27179H4.69427L8.31866 1.6474ZM19.6155 21.7906C19.6155 22.2281 19.262 22.5938 18.8124 22.5938H5.25623C4.81348 22.5938 4.45312 22.2334 4.45312 21.7906V6.67822H7.51556C8.73376 6.67822 9.72491 5.68707 9.72491 4.46887V1.40625H18.8124C19.2501 1.40625 19.6155 1.76001 19.6155 2.20935V21.7906Z",
    fill: "#364863"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 8H9.09985C8.49341 8 8 8.46917 8 9.04603V12.422C8 12.9976 8.49126 13.466 9.09595 13.468V15L11.4108 13.468H14.9001C15.5066 13.468 16 12.9988 16 12.422V9.04603C16 8.46917 15.5066 8 14.9001 8ZM15 11.8998C15 12.2307 14.7169 12.5 14.3689 12.5H11.2638L9.96484 13.6787V12.5542H9.5C9.152 12.5542 8.8689 12.2849 8.8689 11.954V9.65441C8.8689 9.32339 9.152 9.05419 9.5 9.05419L14.3689 9C14.7169 9 15 9.26921 15 9.60022V11.8998Z",
    fill: "#364863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownProtocol);
export default __webpack_public_path__ + "static/media/dropdown-protocol.ac53f208946050b13182dc1b88dc144d.svg";
export { ForwardRef as ReactComponent };